"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DirectDebitSummaryUI = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../shared/core");
var number_1 = require("../../../../../shared/core/utils/number");
var analytics_subjects_1 = require("../../../analytics-subjects");
var copy_1 = require("../../../copy");
var components_1 = require("../ui/components");
var DirectDebitSummaryUI = function (_a) {
    var _b;
    var directDebit = _a.directDebit, recommendedDirectDebit = _a.recommendedDirectDebit;
    var _c = (0, core_1.useComponents)(), Margin = _c.Margin, SummaryCard = _c.SummaryCard;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    var hasDirectDebit = directDebit.amount !== undefined;
    var ownsDd = directDebit.customerOwnsMandate !== false;
    var features = (0, core_1.useFeatureContext)().features;
    return (react_1.default.createElement(ui_tools_1.AnalyticsData, { data: { hasDirectDebit: hasDirectDebit, ownsDd: ownsDd } },
        react_1.default.createElement(ui_tools_1.AnalyticsView, { name: analytics_subjects_1.DIRECT_DEBIT_SUMMARY, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
            react_1.default.createElement(SummaryCard, { heading: hasDirectDebit ? (react_1.default.createElement(Copy, { copyKey: "monthlyDirectDebitHeading" })) : (react_1.default.createElement(Copy, { copyKey: "ddSetupHeading" })), icon: "payments", footer: react_1.default.createElement(components_1.Footer, { hasDirectDebit: hasDirectDebit }) }, directDebit.amount !== undefined ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", null,
                    react_1.default.createElement(Margin, { bottom: 4 },
                        react_1.default.createElement(DirectDebitAmount, { amount: directDebit.amount, dayOfMonth: directDebit.dayOfMonth })),
                    !(features === null || features === void 0 ? void 0 : features.hideRecommendedDirectDebit) &&
                        recommendedDirectDebit ? (react_1.default.createElement("div", { "data-testid": "ddsummary-recdd" },
                        react_1.default.createElement(components_1.RecommendedDirectDebit, { directDebit: directDebit, recommendedDirectDebit: recommendedDirectDebit, hasDirectDebit: hasDirectDebit }))) : null),
                !ownsDd ? (react_1.default.createElement("div", null,
                    react_1.default.createElement(Margin, { top: 4 },
                        react_1.default.createElement(Copy, { copyKey: "notOwnerOfDd" })))) : null)) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", null,
                    react_1.default.createElement(Copy, { copyKey: "ddSetupDescription" }))))))));
};
exports.DirectDebitSummaryUI = DirectDebitSummaryUI;
var DirectDebitAmount = function (_a) {
    var amount = _a.amount, dayOfMonth = _a.dayOfMonth;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    var formattedAmount = parseFloat(amount.amount) - parseInt(amount.amount) > 0
        ? (0, core_1.absoluteMajor2DP)((0, core_1.majorToMinor)(amount.amount, amount.currencyUnit))
        : (0, core_1.absoluteMajor0DP)((0, core_1.majorToMinor)(amount.amount, amount.currencyUnit));
    var formattedDay = dayOfMonth ? (0, number_1.formatNumberWithSuffix)(dayOfMonth) : null;
    return formattedDay ? (react_1.default.createElement(Copy, { copyKey: "directDebitAmountWithDay", values: {
            amount: formattedAmount,
            day: formattedDay ? formattedDay : '',
        } })) : (react_1.default.createElement(Copy, { copyKey: "directDebitAmount", values: { amount: formattedAmount } }));
};
